import {
  OpBanUserDocument,
  OpModerationNsfwDocument,
  OpRefreshMediaSafetyScoreDocument,
  OpRefreshTextSafetyScoreDocument,
  OpRemoveCommentTurnstileDocument,
  OpRequireCommentTurnstileDocument,
  OpResetUserAvatarDocument,
  OpResetUserCoverDocument,
  OpShadowBanUserDocument,
  OpUnBanUserDocument,
} from './generated/graphql'
import { createMutationHelper } from './utils'

export const [useOpRefreshMediaSafetyScore, executeOpRefreshMediaSafetyScore] =
  createMutationHelper(OpRefreshMediaSafetyScoreDocument)

export const [useOpRefreshTextSafetyScore, executeOpRefreshTextSafetyScore] =
  createMutationHelper(OpRefreshTextSafetyScoreDocument)

export const [useOpModerationNSFW, executeOpModerationNSFW] =
  createMutationHelper(OpModerationNsfwDocument)

export const [useOpBanUser, executeOpBanUser] =
  createMutationHelper(OpBanUserDocument)

export const [useOpUnBanUser, executeOpUnBanUser] =
  createMutationHelper(OpUnBanUserDocument)

export const [useOpShadowBanUser, executeOpShadowBanUser] =
  createMutationHelper(OpShadowBanUserDocument)

export const [useOpResetUserAvatar, executeOpResetUserAvatar] =
  createMutationHelper(OpResetUserAvatarDocument)

export const [useOpResetUserCover, executeOpResetUserCover] =
  createMutationHelper(OpResetUserCoverDocument)

export const [useOpRequireCommentTurnstile, executeOpRequireCommentTurnstile] =
  createMutationHelper(OpRequireCommentTurnstileDocument)

export const [useOpRemoveCommentTurnstile, executeOpRemoveCommentTurnstile] =
  createMutationHelper(OpRemoveCommentTurnstileDocument)
